var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp.is,_vm._g(_vm._b({tag:"component"},'component',Object.assign({}, _vm.$attrs, _vm.comp.attrs),false),Object.assign({}, _vm.$listeners, (_vm.comp.listeners || {}))),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }